import { apiFetch } from '@/api/client';
import type {
  ConfigEntry,
  ConfigTestResult,
  ConfigAuditRow,
  TestOutcome,
} from '@/types';

export const configApi = {
  list: () =>
    apiFetch<{ entries: ConfigEntry[] }>('/config/').then((r) => r.entries),

  get: (key: string) =>
    apiFetch<{ key: string; metadata: ConfigEntry }>(
      `/config/${encodeURIComponent(key)}`,
    ),

  reveal: (key: string, reason?: string) =>
    apiFetch<{ key: string; value: string; metadata: ConfigEntry }>(
      `/config/${encodeURIComponent(key)}?reveal=true`,
      { headers: reason ? { 'X-Reason': reason } : undefined },
    ),

  put: (key: string, value: string) =>
    apiFetch<void>(`/config/${encodeURIComponent(key)}`, {
      method: 'PUT',
      body: JSON.stringify({ value }),
    }),

  remove: (key: string, note?: string) => {
    const qs = note ? `?note=${encodeURIComponent(note)}` : '';
    return apiFetch<void>(`/config/${encodeURIComponent(key)}${qs}`, {
      method: 'DELETE',
    });
  },

  test: (key: string, value: string) =>
    apiFetch<ConfigTestResult>(`/config/${encodeURIComponent(key)}/test`, {
      method: 'POST',
      body: JSON.stringify({ value }),
    }),

  // Tests the credential already stored for `key` (no plaintext round-trip).
  // Server route lands in ST3; the integration cards call it now.
  testStored: (key: string) =>
    apiFetch<TestOutcome>(`/config/${encodeURIComponent(key)}/test-stored`, {
      method: 'POST',
      body: JSON.stringify({}),
    }),

  reloadOAuth: () =>
    apiFetch<{ reloaded: true }>(`/config/oauth/reload`, { method: 'POST' }),

  listAudit: (opts: { key?: string; limit?: number; offset?: number } = {}) => {
    const params = new URLSearchParams();
    if (opts.key) params.set('key', opts.key);
    if (opts.limit) params.set('limit', String(opts.limit));
    if (opts.offset) params.set('offset', String(opts.offset));
    const qs = params.toString();
    return apiFetch<{ entries: ConfigAuditRow[]; total: number }>(
      `/config/audit${qs ? '?' + qs : ''}`,
    );
  },
};
